import callAPiBase from './base';

const walletExpirationSettingsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/walletExpirationSettingsGet',
      method: 'GET',
      useToken: true,
      title: 'Wallet Expiration Settings - Get',
      params,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/walletExpirationSettingsUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Wallet Expiration Settings - Update',
      data,
    }),
};

export { walletExpirationSettingsApi };
export default walletExpirationSettingsApi;
